import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState } from 'react';
import { Container, Background } from '@lendi-jam/atoms';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import Grid from '@lendi-ui/grid';
import Spinner from '@lendi-ui/spinner';
import { Link as Link$1, Heading, Body } from '@lendi-ui/typography';
import { useSession, Status } from '@lendi/lala-react';
import { getAPIBaseURL } from '@lendi/lala-utils';
import axios from 'axios';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import Alert from '@lendi-ui/alert';
import { gte, between } from '@lendi-ui/breakpoint';
import { Button } from '@lendi-ui/button';
import { color } from '@lendi-ui/color';
import { mb, mr, m, pr } from '@lendi-ui/spacing';
import CustomAddressPicker from '@lendi/address-picker';
import styled from 'styled-components';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;
var Collection = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", ";\n  ", "\n"])), mb('xs'), gte('tablet')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-direction: row;\n  "]))));
var StyledButton = styled(Button)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  min-height: 48px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n  ", "\n"])), mb('sm'), gte('tablet')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n\n    &:last-child {\n      ", "\n      ", "\n    }\n  "])), mb('nil'), mr('sm'), mb('nil'), mr('nil')));
var HeroTitle = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n\n  ", "\n\n  h1,\n  p,\n  a {\n    color: ", ";\n    ", "\n  }\n"])), "\n    @media (min-width: 1025px) {\n      margin-top: 88px\n    }\n  ", between('xs', 'xl')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", ";\n  "])), mb('md')), gte('xl')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", ";\n  "])), mb('xl')), function (_ref) {
  var hasBackground = _ref.hasBackground;
  return hasBackground ? color('shade.0') : color('shade.700');
}, m('nil'));
var HeroGridContainer = styled(Container)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  ", "\n\n  ", " {\n    ", "\n  }\n"])), gte('lg')(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      box-sizing: border-box;\n      ", "\n      max-width: 48rem;\n    "])), pr('md')), StyledButton, gte('sm')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        width: 248px;\n    "]))));
var HeroSubtitle = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n\n  h4, p, a {\n    color: ", ";\n    ", "\n  }\n"])), between('xs', 'lg')(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    ", "\n  "])), mb('xl')), between('lg', 'xl')(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    ", "\n  "])), mb('md')), gte('xl')(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    ", "\n  "])), mb('xl')), function (_ref2) {
  var hasBackground = _ref2.hasBackground;
  return hasBackground ? color('shade.0') : color('shade.700');
}, m('nil'));
var AddressPicker = styled(CustomAddressPicker)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  ", "\n\n  & > div:first-child > div:first-child:not(.modal-container) {\n    max-height: 48px;\n  }\n"])), between('xs', 'sm')(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    ", "\n  "])), mb('sm')));
var Link = styled(Link$1)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  text-decoration: none;\n  color: #1c9e8d;\n  &:visited {\n    color: #1c9e8d;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n"])));
var StyledSubtitle = styled(Heading)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  color: ", ";\n  line-height: 1.3;\n  letter-spacing: normal;\n"])), color('shade.0'));
var AbsoluteWrapper = styled.span(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 10%;\n"])));
var StyledAlert = styled(Alert)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  width: 100%;\n  ", "\n"])), gte('lg')(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    width: 164%;\n    z-index: 1;\n  "]))));
var AddressPickerContainer = styled.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  ", ";\n  row-gap: 16px;\n  align-items: flex-start;\n  box-sizing: border-box;\n  flex-direction: row;\n  justify-content: flex-start;\n  -webkit-box-align: stretch;\n  display: flex;\n  flex-wrap: nowrap;\n  width: 100%;\n"])), mr('sm'));

var capitiliseFirstLetter = function capitiliseFirstLetter(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

/**
 *  formatCoreLogicAddress(address) takes the AddressObject returned by the (shaka) address-picker component
 *  It returns a formatted address string, usable by CoreLogic API to consume (no commas, no country).
 *  The original function(s) are taken directly from address-picker utils.
 * */

var formatCoreLogicAddress = function formatCoreLogicAddress(address) {
  var formattedAddress = function formattedAddress(formatString, addressPart) {
    var concatBefore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var concatAfter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    return formatString.concat(concatBefore, addressPart, concatAfter);
  };
  var formatString = '';
  formatString = address.unit ? formattedAddress(formatString, address.unit, '', '/') : formatString;
  formatString = address.deliveryAddress ? formattedAddress(formatString, address.deliveryAddress, '') : formatString;
  formatString = address.level ? formattedAddress(formatString, address.level, ' Level ', ' ') : formatString;
  formatString = address.streetNumber ? formattedAddress(formatString, address.streetNumber) : formatString;
  formatString = address.streetName ? formattedAddress(formatString, address.streetName, ' ') : formatString;
  formatString = address.streetType ? formattedAddress(formatString, address.streetType, ' ') : formatString;
  formatString = address.streetSuffix ? formattedAddress(formatString, address.streetSuffix, ' ') : formatString;
  formatString = address.suburb ? formattedAddress(formatString, capitiliseFirstLetter(address.suburb), ' ') : formatString;
  formatString = address.state ? formattedAddress(formatString, address.state.toUpperCase(), ' ') : formatString;
  formatString = address.postcode ? formattedAddress(formatString, address.postcode, ' ') : formatString;
  return formatString.replace(/^,/g, '').trim();
};

var AddressSearch = function AddressSearch(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    background = _ref.background,
    backgroundSharp = _ref.backgroundSharp,
    mobileImage = _ref.mobileImage,
    subtitle = _ref.subtitle,
    title = _ref.title,
    trackSearchButtonClick = _ref.trackSearchButtonClick,
    trackLinkClick = _ref.trackLinkClick,
    onError = _ref.onError;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    address = _useState2[0],
    setAddress = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    addressObj = _useState8[0],
    setAddressObj = _useState8[1];
  var session = useSession();
  var isAuthenticated = session.status === Status.Authenticated;
  var getPropertyReport = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(address) {
      var _yield$axios$get, data, propertyReportData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return axios.get("/v1/property-report/property/search/address/" + encodeURIComponent(address), {
              baseURL: getAPIBaseURL(session.environment),
              headers: {
                Authorization: 'Bearer undefined',
                'Content-Type': 'application/json'
              }
            });
          case 4:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            // This is the contractual agreement on data structure between UIS & Acquire team.
            propertyReportData = _objectSpread(_objectSpread({}, data.data), {}, {
              addressObject: addressObj
            });
            sessionStorage.setItem('property_report_cms', JSON.stringify(propertyReportData));
            setError(false);
            setIsLoading(false);
            if (typeof window !== 'undefined') {
              window.location.href = embedMarketingTrackingIntoURL('/property-report/relationship/', false);
            }
            _context.next = 18;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            onError && onError(_context.t0);
            setError(true);
            setIsLoading(false);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 13]]);
    }));
    return function getPropertyReport(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var buttonText = 'Search';
  var linkText = isAuthenticated ? 'View your Property Reports' : 'Login to access';
  var onSelect = function onSelect(selection) {
    setAddressObj(selection);
  };
  var onClick = function onClick() {
    trackSearchButtonClick && trackSearchButtonClick(buttonText);
    var formattedAddress = addressObj && formatCoreLogicAddress(addressObj);
    formattedAddress && getPropertyReport(formattedAddress);
  };
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx(Background, {
      background: background,
      backgroundColor: "#003046",
      alignment: "left",
      backgroundSharp: backgroundSharp,
      mobileImage: mobileImage,
      alt: alt,
      children: /*#__PURE__*/jsx(Grid, {
        gutter: "nil",
        halign: "right",
        children: /*#__PURE__*/jsx(Grid.Unit, {
          size: 1,
          children: /*#__PURE__*/jsxs(HeroGridContainer, {
            children: [error && /*#__PURE__*/jsx(StyledAlert, {
              variant: "error",
              heading: "No property matches found ",
              children: "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0Please search a different address"
            }), title && /*#__PURE__*/jsx(HeroTitle, {
              hasBackground: !!background,
              className: "HeroImage-title",
              children: /*#__PURE__*/jsx(Heading, {
                size: "xl",
                children: title
              })
            }), subtitle && /*#__PURE__*/jsx(HeroSubtitle, {
              hasBackground: !!background,
              className: "HeroImage-subtitle",
              children: /*#__PURE__*/jsx(StyledSubtitle, {
                size: "md",
                children: subtitle
              })
            }), /*#__PURE__*/jsxs(Collection, {
              children: [/*#__PURE__*/jsx(AddressPickerContainer, {
                children: /*#__PURE__*/jsx(AddressPicker, {
                  manualAddressInputType: "both",
                  value: address,
                  onSelectAddress: onSelect,
                  onChange: function onChange() {
                    return null;
                  },
                  regionSearchOnly: false,
                  source: "corelogic",
                  country: "au",
                  dataset: "GNAF",
                  size: "lg",
                  isDisabled: isLoading,
                  onReset: function onReset() {
                    setAddress('');
                  },
                  onException: function onException() {
                    // TODO: Report to Datadog
                  }
                })
              }), /*#__PURE__*/jsxs(StyledButton, {
                isDisabled: isLoading || !addressObj,
                className: "AddressSearch-button",
                onClick: onClick,
                size: "md",
                variant: "primary",
                "aria-label": "search for a property address",
                children: [isLoading && /*#__PURE__*/jsx(AbsoluteWrapper, {
                  children: /*#__PURE__*/jsx(Spinner, {
                    variant: "light"
                  })
                }), buttonText]
              })]
            }), /*#__PURE__*/jsxs(Body, {
              size: "sm",
              color: "shade.0",
              children: ["Looking for a previous property report?", ' ', /*#__PURE__*/jsx(Link, {
                href: embedMarketingTrackingIntoURL('/property-report/my-properties/', false),
                onClick: function onClick() {
                  trackLinkClick && trackLinkClick(linkText);
                },
                children: linkText
              })]
            })]
          })
        })
      })
    })
  });
};

export { AddressSearch as default };
